import { Semver } from '../../utils/Semver';
export function equalToSemverMatcherContext(ruleAttr) {
    var ruleSemver = new Semver(ruleAttr);
    return function equalToSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver(runtimeAttr);
        var isEqual = ruleSemver.version === runtimeSemver.version;
        return isEqual;
    };
}
